import React, { FC } from 'react';

import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const nameSpace = 'uploadFiles.myFilesPopup.navWarning';

interface UploadNavigationWarningModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const UploadNavigationWarningModal: FC<UploadNavigationWarningModalProps> = ({
    isOpen,
    onConfirm,
    onCancel,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={isOpen}
            centered
            closable={false}
            maskClosable={false}
            title={t(`${nameSpace}.title`)}
            onCancel={onCancel}
            footer={[
                <Button key="stay" onClick={onCancel} data-testid="uploadNavWarning_stay">
                    {t(`${nameSpace}.stay`)}
                </Button>,
                <Button key="confirm" danger type="primary" onClick={onConfirm} data-testid="uploadNavWarning_confirm">
                    {t(`${nameSpace}.confirm`)}
                </Button>,
            ]}
        >
            {t(`${nameSpace}.description`)}
        </Modal>
    );
};

export default UploadNavigationWarningModal;
